import { render, staticRenderFns } from "./SalesClassTab.vue?vue&type=template&id=4f7fd403"
import script from "./SalesClassTab.vue?vue&type=script&lang=js"
export * from "./SalesClassTab.vue?vue&type=script&lang=js"
import style0 from "./SalesClassTab.vue?vue&type=style&index=0&id=4f7fd403&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports